import React, { FC } from 'react'

import { InterSvgIcon } from 'components'

import { Text } from '@interco/inter-ui/components/Text'
import IcChevronRight from '@interco/icons/core/action-navigation/ic_chevron_right'

import { DescriptionArea, MenuItemButtonContainer } from '../styles/MenuItemButton.styles'
import { TMenuItemButtonViewProps } from '../types/MenuItemButton.types'

export const MenuItemButtonView: FC<TMenuItemButtonViewProps> = ({
  icon,
  title,
  details,
  iconStyle,
  onClick,
  dataTestId,
}) => (
  <MenuItemButtonContainer onClick={onClick} data-testid={dataTestId}>
    <InterSvgIcon iconRef={icon} {...iconStyle} />
    <DescriptionArea>
      <Text variant="body-3" color="typography" colorWeight={500} as="p" bold>
        {title}
      </Text>
      {details && (
        <Text variant="caption-1" color="typography" colorWeight={400} as="p">
          {details}
        </Text>
      )}
    </DescriptionArea>
    <IcChevronRight color="var(--secondary500)" width={24} height={24} />
  </MenuItemButtonContainer>
)
